import gql from 'graphql-tag'

export const GetDesignByIdQuery = gql`
  query GetDesignByID($designId: String!, $teamStoreItem: String) {
    design: sharedDesignShortId(
      designId: $designId
      teamStoreItem: $teamStoreItem
    ) {
      id
      shared
      name
      canEdit: can_edit
      shortId: short_id
      totalOrders: total_orders
      teamEnable: team_enable
      teamName: team_name
      from_ca: team_from_ca
      predyedName: predyed_name
      onBatchStore
      teamOnDemand: team_on_demand_mode
      teamCouponReminder: team_coupon_reminder
      teamGracePeriod: team_grace_period
      fixedPrice: team_fixed_price
      isReseller: is_reseller
      variables {
        variableOne: variable_one
        variableOneLength: variable_one_length
        variableOneCaps: variable_one_caps
        variableTwo: variable_two
        variableTwoLength: variable_two_length
        variableTwoCaps: variable_two_caps
      }
      resellerPrice: reseller_price {
        abbreviation
        shortName: short_name
        quantity
        price
      }
      teamPrice: team_price {
        abbreviation
        shortName: short_name
        quantity
        price
      }
      product {
        id
        productId: id
        yotpoId: yotpo_id
        name
        active
        chart
        code
        glbEnabled: glb_enabled
        discontinued
        sizeTag: size_tag
        modelSize: model_size
        type: short_description
        onlyProDesign: only_pro_design
        shortDescription: short_description
        genderId: gender_id
        customizable: design_center
        customLink: custom_link
        description
        descriptionRich: description_rich
        details
        hideFitStyles: hide_fit_styles
        youthCombined: youth_combined
        bibraceFullPrint: bibrace_fullprint
        relatedItemTag: related_item_tag
        materials: materials_info
        fitPreferences: fit_preferences
        twoPieces: two_pieces
        upgradeOne: upgrade_one {
          id
          shortId: short_id
          enabled
          name
          url
          defaultOption: default_option
          modalImage: modal_image
          mobileImage: mobile_image
          options {
            aud
            id
            cad
            shortId: short_id
            gbp
            name
            usd
            eur
          }
        }
        upgradeTwo: upgrade_two {
          id
          shortId: short_id
          enabled
          name
          url
          defaultOption: default_option
          modalImage: modal_image
          mobileImage: mobile_image
          options {
            aud
            id
            cad
            shortId: short_id
            gbp
            name
            usd
            eur
          }
        }
        upgradeThree: upgrade_three {
          id
          shortId: short_id
          enabled
          name
          url
          defaultOption: default_option
          modalImage: modal_image
          mobileImage: mobile_image
          options {
            aud
            id
            cad
            shortId: short_id
            gbp
            name
            usd
            eur
          }
        }
        bannerMaterials: banner_materials {
          id
          url
        }
        mediaFiles: media_files {
          url
          savedDesignPage: saved_design_page
          urlMobile: url_mobile
          width
          isText: is_text
          richText: rich_text
          backgroundColor: background_color
          verticalAlign: vertical_align
          altDescription: alt_description
          cssStyle: css_style
          backgroundImage: background_image
        }
        genders {
          id
          name: gender
        }
        fitStyles {
          id
          name: description
          info
        }
        sizeRange: size_range {
          id
          name
          isYouth: is_youth
        }
        images: original_pictures {
          front: front_image
          back: back_image
          left: left_image
          right: right_image
          genderId: gender_id
          colorId: color_id
        }
        priceRange {
          price
          quantity
          abbreviation
          shortName: short_name
        }
        yotpoAverageScore {
          total: total_reviews
          averageScore: average_score
        }
        obj
        mtl
        label
        bumpMap: bump_map
        flatlock
        binding {
          white
          black
        }
        zipper {
          white
          black
        }
        zipper2 {
          white
          black
        }
        bibBrace {
          white
          black
        }
        infoFlag: info_flag
        infoMessage: info_message
      }
      colors {
        id
        colordesc
        color
        image
      }
      image
      flatlockColor: flatlock_code
      zipperColor: zipper_color
      zipper2Color: zipper2_color
      bindingColor: binding_color
      bibBraceColor: bib_brace_color
      shared
      svg: output_svg
      code
      createdAt: created_at
      proDesign: pro_design
      proCertified: pro_certified
      printApproved: print_approved
      qualityWarning: quality_warning
      isDraft: is_draft
      requirePrintApproval: require_print_approval
      requireProCertification: require_pro_certification
      png: output_png
    }
  }
`

export const GetDesignByIdStoreQuery = gql`
  query GetDesignByID($designId: String!, $teamStoreItem: String) {
    design: sharedDesignShortId(
      designId: $designId
      teamStoreItem: $teamStoreItem
    ) {
      id
      shared
      name
      canEdit: can_edit
      shortId: short_id
      totalOrders: total_orders
      teamEnable: team_enable
      teamName: team_name
      from_ca: team_from_ca
      predyedName: predyed_name
      teamOnDemand: team_on_demand_mode
      teamGracePeriod: team_grace_period
      teamCouponReminder: team_coupon_reminder
      fixedPrice: team_fixed_price
      isReseller: is_reseller
      variables {
        variableOne: variable_one
        variableOneLength: variable_one_length
        variableOneCaps: variable_one_caps
        variableTwo: variable_two
        variableTwoLength: variable_two_length
        variableTwoCaps: variable_two_caps
      }
      resellerPrice: reseller_price {
        abbreviation
        shortName: short_name
        quantity
        price
      }
      teamPrice: team_price {
        abbreviation
        shortName: short_name
        quantity
        price
      }
      product {
        id
        productId: id
        yotpoId: yotpo_id
        name
        active
        chart
        code
        discontinued
        sizeTag: size_tag
        modelSize: model_size
        glbEnabled: glb_enabled
        type: short_description
        onlyProDesign: only_pro_design
        shortDescription: short_description
        genderId: gender_id
        customLink: custom_link
        customizable: design_center
        description
        descriptionRich: description_rich
        details
        fitPreferences: fit_preferences
        hideFitStyles: hide_fit_styles
        youthCombined: youth_combined
        bibraceFullPrint: bibrace_fullprint
        relatedItemTag: related_item_tag
        materials: materials_info
        twoPieces: two_pieces
        upgradeOne: upgrade_one {
          id
          shortId: short_id
          enabled
          name
          url
          defaultOption: default_option
          modalImage: modal_image
          mobileImage: mobile_image
          options {
            aud
            id
            cad
            shortId: short_id
            gbp
            name
            usd
            eur
          }
        }
        upgradeTwo: upgrade_two {
          id
          shortId: short_id
          enabled
          name
          url
          defaultOption: default_option
          modalImage: modal_image
          mobileImage: mobile_image
          options {
            aud
            id
            cad
            shortId: short_id
            gbp
            name
            usd
            eur
          }
        }
        upgradeThree: upgrade_three {
          id
          shortId: short_id
          enabled
          name
          url
          defaultOption: default_option
          modalImage: modal_image
          mobileImage: mobile_image
          options {
            aud
            id
            cad
            shortId: short_id
            gbp
            name
            usd
            eur
          }
        }
        bannerMaterials: banner_materials {
          id
          url
        }
        mediaFiles: media_files {
          url
          savedDesignPage: saved_design_page
          urlMobile: url_mobile
          width
          isText: is_text
          richText: rich_text
          backgroundColor: background_color
          verticalAlign: vertical_align
          altDescription: alt_description
          cssStyle: css_style
          backgroundImage: background_image
        }
        genders {
          id
          name: gender
        }
        fitStyles {
          id
          name: description
          info
        }
        sizeRange: size_range {
          id
          name
          isYouth: is_youth
        }
        images: original_pictures {
          front: front_image
          back: back_image
          left: left_image
          right: right_image
          genderId: gender_id
          colorId: color_id
        }
        priceRange {
          price
          quantity
          abbreviation
          shortName: short_name
        }
        yotpoAverageScore {
          total: total_reviews
          averageScore: average_score
        }
        obj
        mtl
        label
        bumpMap: bump_map
        flatlock
        binding {
          white
          black
        }
        zipper {
          white
          black
        }
        zipper2 {
          white
          black
        }
        bibBrace {
          white
          black
        }
        infoFlag: info_flag
        infoMessage: info_message
      }
      colors {
        id
        colordesc
        color
        image
      }
      image
      flatlockColor: flatlock_code
      zipperColor: zipper_color
      zipper2Color: zipper2_color
      bindingColor: binding_color
      bibBraceColor: bib_brace_color
      shared
      svg: output_svg
      code
      createdAt: created_at
      proDesign: pro_design
      proCertified: pro_certified
      printApproved: print_approved
      qualityWarning: quality_warning
      isDraft: is_draft
      requirePrintApproval: require_print_approval
      png: output_png
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        country_code
      }
      reseller {
        status
        currency
        margin
        comission
        paypalAccount: paypal_account
      }
    }
  }
`

export const getDesignVariables = gql`
  query GetDesignVariables($id: String!) {
    designVariables: getDesignVariables(id: $id) {
      id
      variableOne: variable_one
      variableTwo: variable_two
      oneLength: variable_one_length
      twoLength: variable_two_length
      variableOneCaps: variable_one_caps
      variableTwoCaps: variable_two_caps
    }
  }
`

export const getVariantsFromProduct = gql`
  query getVariants($id: Int!) {
    getVariants(id: $id) {
      id: short_id
      name
      icon
      default: is_default
      obj
      mtl
      glb
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/CustomProductDetail/data.ts